var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"bisnode-tree list-unstyled mb-0 ml-0 p-0"},[_c('tree-node',{attrs:{"node":_vm.root,"is-root":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }